import {ReactElement} from "react";
import {useGetAsset} from "@/hooks/useAsset";

interface Props {
    assetId: string;
    alt?: string;
    className?: string;
}

function AssetImage(props: Props): ReactElement {

    const {data: asset} = useGetAsset(props.assetId);

    if (!asset) {
        return null;
    }

    // Use pipeUrl when it points to localhost (local dev), otherwise use url (production CDN)
    const imageUrl = asset.pipeUrl?.includes("localhost") ? asset.pipeUrl : asset.url;

    return (
        <div className="asset-image">
            <img
                src={imageUrl}
                alt={props.alt}
                className={props.className}
            />
        </div>
    );
}

export default AssetImage;
